import React, { useEffect } from 'react';

import Icon from "../Icon";

const getCriteriaStatus = (password, confirmPassword) => ({
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
    match: password && password === confirmPassword
});

const PasswordChecklist = ({ password, confirmPassword, onCriteriaChange }) => {
    const criteria = getCriteriaStatus(password, confirmPassword);

    useEffect(() => {
        if (typeof onCriteriaChange === 'function') {
            onCriteriaChange(criteria);
        }
    }, [password, confirmPassword]);

    const getColor = (condition) => (condition ? '#1B9E77' : '#7A7499');
    const getIcon = (condition) => (<Icon name={condition ? 'check' : 'uncheck'} size={16} color={condition ? '#25A95C' : '#7A7499'} />);

    return (
        <ul className="change-color my-2" style={{ listStyle: 'none', paddingLeft: 0, marginTop: 12 }}>
            <li style={{ color: getColor(criteria.length) }}> {getIcon(criteria.length)} Pelo menos 8 caracteres</li>
            <li style={{ color: getColor(criteria.upper) }}> {getIcon(criteria.upper)} Pelo menos 1 letra maiúscula</li>
            <li style={{ color: getColor(criteria.number) }}> {getIcon(criteria.number)} Pelo menos 1 número</li>
            <li style={{ color: getColor(criteria.special) }}> {getIcon(criteria.special)} Pelo menos 1 caractere especial</li>
            <li style={{ color: getColor(criteria.match) }}> {getIcon(criteria.match)} Senhas coincidem</li>
        </ul>
    );
};

export default PasswordChecklist;